import { Box, Dialog, IconButton } from '@mui/material'
import { pdf } from '@react-pdf/renderer'
import axios from 'axios'
import { saveAs } from 'file-saver'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { IoClose, IoReceiptOutline } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { HeaderActions, IFoodOrder, IFoodOrderProduct } from 'safe'
import Loading from '../../components/Display/Loading'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { ThemeContext } from '../../context/ThemeContext'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import { AddProduct } from './AddProduct'
import FoodOrderCard from './FoodOrderCard'
import { FoodOrderForm, IFormFoodOrder } from './FoodOrderForm'
import PdfFoodOrder from './PdfFoodOrder'
const server = process.env.REACT_APP_SERVER_URL

const FoodOrder: React.FC<FoodOrderProps> = ({ setHeaderActions }) => {
  const { user } = useSelector((state: RootState) => state.auth)
  const userPlan = user?.['custom:user_plan']
  const isEmprendedorUser =
    userPlan === 'emprendedor' || userPlan === 'estudiantil'

  const { addAlert } = useSnackBars()
  const { theme } = useContext(ThemeContext)

  const [orders, setOrders] = useState<IFoodOrder[]>([])

  const [tables, setTables] = useState<{ value: string; text: string }[]>([])

  const [isLoadingGet, setIsLoadingGet] = useState<boolean>(false)

  const [isLoadingTables, setisLoadingTables] = useState<boolean>(false)

  const [formModal, setFormModal] = useState<boolean>(false)

  const [addProductModal, setAddProductModal] = useState<boolean>(false)

  const [useType, setUseType] = useState<'create' | 'edit' | 'watch'>('create')

  const [selectedOrder, setSelectedOrder] = useState<IFoodOrder | null>(null)

  const history = useHistory()

  const alreadyInited = useRef(false)

  const [displayConfirm, setDisplayConfirm] = useState<boolean>(false)

  const [selectedOrderProduct, setSelectedOrderProduct] =
    useState<IFoodOrder | null>(null)

  const [visibleMenu, setVisibleMenu] = useState<string>('')

  const onGetOrders = async () => {
    try {
      setIsLoadingGet(true)
      let response = await axios.get<{ orders: IFoodOrder[] }>(
        `${server}/food-order?active=true`
      )
      setOrders(response?.data?.orders)
      setIsLoadingGet(false)
    } catch (error) {
      console.log(error)
      setIsLoadingGet(false)
    }
  }

  const onGetTables = async () => {
    try {
      setisLoadingTables(true)
      let response = await axios.get(`${server}/food-table`)
      setTables(
        response?.data?.tables?.map((table: any) => ({
          value: table?.id,
          text: table?.name,
        }))
      )
      setisLoadingTables(false)
    } catch (error) {
      console.log(error)
      setisLoadingTables(false)
    }
  }

  const onFilterHeader = (obj: { addAction: () => void }) => {
    console.log('USER', user)
    if (
      user['custom:user_role'] === 'master' ||
      user['custom:user_role'] === 'cashier'
    ) {
      return {}
    }
    return obj
  }

  useEffect(() => {
    // No cargar datos ni mostrar acciones si es plan emprendedor
    if (!isEmprendedorUser) {
      onGetOrders()
      onGetTables()

      setHeaderActions(
        onFilterHeader({
          addAction: () => {
            setFormModal(true)
          },
        })
      )
    } else {
      setHeaderActions({})
    }

    return () => {
      setHeaderActions(null)
    }
  }, [setHeaderActions, isEmprendedorUser])

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get('foodOrderId')
    if (orders?.length > 0 && !alreadyInited.current) {
      const order = orders.find((order) => order.id === id)
      if (order) {
        onAssignProducts(order)
        alreadyInited.current = true
      }
    }
  }, [orders])

  const onSubmit = async (data: IFormFoodOrder) => {
    if (useType === 'create') {
      const body = {
        idFoodTable: data.idFoodTable,
        idNevulaUser: user?.sub,
        type: data.type,
        observations: data.observations,
      }
      try {
        addAlert({
          message: 'Cargando',
          status: 'loading',
        })
        let response = await axios.post(`${server}/food-order`, body)
        addAlert({
          message: 'Comanda creada satisfactoriamente',
          status: 'success',
        })
        await onGetOrders()
        setFormModal(false)

        setUseType('create')
      } catch (error: any) {
        if (
          error?.response?.data?.message ===
          'There is already an active order for this food table'
        ) {
          addAlert({
            message: 'Ya existe una comanda activa para esta mesa',
            status: 'error',
          })
        } else {
          addAlert({
            message: 'Error al crear comanda',
            status: 'error',
          })
        }
      }
    } else if (useType === 'edit') {
      let body: any = {
        idFoodTable: data.idFoodTable,
        idNevulaUser: user?.sub,
        type: data.type,
        observations: data.observations,
        id: selectedOrder?.id,
      }

      if (data?.idFoodTable === selectedOrder?.foodTable?.id) {
        body.idFoodTable = null
      }

      try {
        addAlert({
          message: 'Cargando',
          status: 'loading',
        })
        let response = await axios.patch(`${server}/food-order`, body)
        addAlert({
          message: 'Comanda editada satisfactoriamente',
          status: 'success',
        })
        await onGetOrders()
        setFormModal(false)

        setUseType('create')
      } catch (error) {
        addAlert({
          message: 'Error al editar comanda',
          status: 'error',
        })
      }
    }
  }

  const onDelete = async (id: string) => {
    try {
      addAlert({
        message: 'Eliminando comanda...',
        status: 'loading',
      })
      await axios.delete(`${server}/food-order?id=${id}`)
      await onGetOrders()
      addAlert({
        message: 'Comanda eliminada correctamente',
        status: 'success',
      })
    } catch (error) {
      addAlert({
        message: 'Error al eliminar comanda',
        status: 'error',
      })
    }
  }

  const onWatch = async (order: IFoodOrder) => {
    setUseType('watch')
    setSelectedOrder(order)
    setFormModal(true)
  }

  const onEdit = async (order: IFoodOrder) => {
    setUseType('edit')
    setSelectedOrder(order)
    setFormModal(true)
  }

  const onAddProduct = async (order: IFoodOrder) => {
    setSelectedOrderProduct(order)
    setAddProductModal(true)
  }

  const onChangeStatus = async (order: IFoodOrder) => {
    try {
      addAlert({
        message: 'Cambiando estado de comanda...',
        status: 'loading',
      })
      await axios.patch(`${server}/food-order`, {
        active: !order.active + '',
        id: order.id,
      })
      await onGetOrders()
      addAlert({
        message: 'Estado de comanda cambiado correctamente',
        status: 'success',
      })
    } catch (error) {
      addAlert({
        message: 'Error al cambiar estado de comanda',
        status: 'error',
      })
    }
  }

  const onAssignProducts = async (order: IFoodOrder) => {
    setSelectedOrderProduct(order)
    setAddProductModal(true)
  }

  const onChangeStatusProduct = async (
    order: IFoodOrder,
    product: IFoodOrderProduct
  ) => {
    const getOrderIdx = orders.findIndex((o) => o.id === order.id)

    const newStatus =
      product.status === 'pending'
        ? 'ready'
        : product.status === 'ready'
        ? 'delivered'
        : 'pending'

    if (getOrderIdx !== -1) {
      const newOrder = orders[getOrderIdx]
      const getProductIdx = newOrder.items.findIndex((p) => p.id === product.id)
      if (getProductIdx !== -1) {
        newOrder.items[getProductIdx] = { ...product, status: newStatus }
        setOrders([...orders])
      }
    }

    try {
      await axios.patch(`${server}/food-order/item`, {
        id: +product.id,
        status: newStatus,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onCloseOrder = async (order: IFoodOrder) => {
    if (order?.items?.length > 0) {
      history?.push(`/dashboard/restaurantes/cerrar-comanda?id=${order.id}`)
    } else {
      setDisplayConfirm(true)
    }
  }

  const onPrintOrder = async (order: IFoodOrder) => {
    const respTenantInfo = await axios.get(`${server}/user/tenant`)

    try {
      const blob = await pdf(
        <PdfFoodOrder order={order} tenantInfo={respTenantInfo?.data?.tenant} />
      ).toBlob()
      saveAs(blob, `Comanda-${order.foodOrderCode}`)
    } catch (error) {
      addAlert({
        message: 'Error al generar el PDF',
        status: 'error',
      })
    }
  }
  const onDeleteItem = async (item: IFoodOrderProduct) => {
    try {
      await axios.delete(`${server}/food-order/item?id=${item.id}`)
      await onGetOrders()
    } catch (error) {
      console.log(error)
    }
  }

  if (isLoadingGet) {
    return <Loading />
  }

  // Mostrar mensaje de upgrade si es plan emprendedor
  if (isEmprendedorUser) {
    return (
      <div className="flex flex-col justify-center items-center h-full p-4">
        <div
          className="p-8 rounded-lg shadow-lg max-w-2xl text-center"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="mb-6">
            <IoReceiptOutline
              className="mx-auto mb-4"
              size={64}
              style={{ color: '#507CDC' }}
            />
          </div>
          <h2 className="text-2xl font-bold mb-4 dark:text-white">
            Funcionalidad Premium
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-6">
            Para gestionar comandas debes mejorar tu plan a{' '}
            <strong className="text-primary">"PYME"</strong>
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-500">
            El plan Corporativo incluye sistema completo de comandas con órdenes
            en tiempo real, asignación a cocina, seguimiento de pedidos,
            modificaciones sobre la marcha y mucho más.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {orders.length === 0 && !isLoadingGet && (
        <div className="flex justify-center items-center h-[60vh]">
          <h1 className="text-2xl font-bold">No hay comandas disponibles</h1>
        </div>
      )}

      {orders.length > 0 && (
        <div
          // className=""
          style={{
            // columnCount: 4,
            columnGap: '1.7rem',
          }}
          className="mt-4 md:columns-2 lg:columns-3 xl:columns-4"
        >
          {orders.map((order) => (
            <div
              key={order.id}
              style={{ breakInside: 'avoid', marginBottom: '1.25rem' }}
            >
              <FoodOrderCard
                order={order}
                onDelete={onDelete}
                onWatch={() => onWatch(order as any)}
                onEdit={() => onEdit(order as any)}
                onAddProduct={onAddProduct}
                onChangeStatus={onChangeStatus}
                onAssignProducts={onAssignProducts}
                visibleMenu={visibleMenu}
                setVisibleMenu={setVisibleMenu}
                onChangeStatusProduct={onChangeStatusProduct}
                onCloseOrder={onCloseOrder}
                onPrintOrder={onPrintOrder}
                onDeleteItem={onDeleteItem}
              />
            </div>
          ))}
        </div>
      )}

      <Modal
        display={formModal}
        onClose={() => {
          setFormModal(false)
          setUseType('create')
          setSelectedOrder(null)
        }}
      >
        <FoodOrderForm
          onSubmit={onSubmit}
          onClose={() => {
            setFormModal(false)
            setUseType('create')
            setSelectedOrder(null)
          }}
          useType={useType}
          isLoading={false}
          defaultValues={selectedOrder}
          tables={tables}
        />
      </Modal>

      <Dialog
        open={addProductModal}
        onClose={async () => {
          await onGetOrders()
          setAddProductModal(false)
        }}
        PaperProps={{
          style: {
            overflow: 'visible',
            boxShadow: 'none',
          },
        }}
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              overflow: 'visible',
            },
          },
        }}
      >
        <Box sx={{ padding: 5 }}>
          <IconButton
            aria-label="close"
            onClick={async () => {
              await onGetOrders()
              setAddProductModal(false)
            }}
            sx={(theme) => ({
              position: 'absolute',
              right: 10,
              top: 15,
              color: theme.palette.grey[500],
            })}
          >
            <IoClose />
          </IconButton>

          <AddProduct
            onSubmit={onSubmit}
            onClose={async () => {
              await onGetOrders()
              setAddProductModal(false)
            }}
            useType={useType}
            isLoading={false}
            defaultValues={selectedOrderProduct!}
            tables={tables}
            onLoad={() => {}}
          />
        </Box>
      </Dialog>

      <ModalConfirm
        title="Esta comanda no se puede cerrar porque no tiene productos"
        displayConfirmModal={displayConfirm}
        isInfo={true}
        onCancel={() => setDisplayConfirm(false)}
      />
    </div>
  )
}

interface FoodOrderProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
}

export default FoodOrder
